import base from "../baseurl";
import token from "../getTk";

const Create = async (State) => {
  const tokenA = token.get();
  const api = base.extend({
    hooks: {
      beforeRequest: [
        (request) => {
          request.headers.set("jwt", `${tokenA}`);
        },
      ],
    },
  });
  const Create = await api
    .post("election/delete", {
      json: {
        electionUuid: State,
      },
    })
    .json();

  return Create;
};

export default Create;
